<div
  class="modal-backdrop-wrapper"
  *ngIf="showModal"
>
  <div class="custom-modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ tyreData ? "Edit Tyre" : "Add Tyre" }}
        </h5>
        <button type="button" class="close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form [formGroup]="tyreForm" (ngSubmit)="onSubmit()">
        <div class="modal-body">
          <div class="form-group">
            <label>No. of Tyres</label>
            <input type="number" formControlName="tyreType" class="form-control" />
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
          <button type="submit" class="btn btn-primary">
            {{ tyreData ? "Update" : "Add" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
